var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrame2 = function SvgFrame2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 107,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.007 67.676H35.975a7.244 7.244 0 0 1-7.24-7.24V22.783a7.244 7.244 0 0 1 7.24-7.24H48.37c1.321 0 2.567.601 3.384 1.633l3.19 3.974a4.345 4.345 0 0 0 3.384 1.633h32.667c1.923 0 3.76.763 5.124 2.116a7.252 7.252 0 0 1 2.116 5.124v30.411c.011 4.007-3.233 7.24-7.23 7.24Z",
    fill: "url(#Frame2_svg__a)",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.7 36.072H42.463a1.61 1.61 0 0 1-1.611-1.611c0-.892.72-1.611 1.61-1.611H85.69c.892 0 1.612.72 1.612 1.61a1.6 1.6 0 0 1-1.6 1.612ZM85.7 46.868H42.463a1.61 1.61 0 0 1-1.611-1.611c0-.892.72-1.611 1.61-1.611H85.69c.892 0 1.612.72 1.612 1.61a1.593 1.593 0 0 1-1.6 1.612ZM80.114 57.675H42.463a1.61 1.61 0 0 1-1.611-1.611c0-.892.72-1.612 1.61-1.612h37.641c.892 0 1.612.72 1.612 1.611a1.593 1.593 0 0 1-1.6 1.612Z",
    fill: "#D78C02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.817 57.911H9.292a2.29 2.29 0 0 1-2.288-2.288v-10.85a2.29 2.29 0 0 1 2.288-2.288h67.525a2.29 2.29 0 0 1 2.289 2.288v10.84a2.292 2.292 0 0 1-2.289 2.298Z",
    fill: "#FED896"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.05 54.012a3.813 3.813 0 1 0 0-7.627 3.813 3.813 0 0 0 0 7.627Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m51.112 50.133-3.438 3.438a2.354 2.354 0 0 1-3.32 0 2.354 2.354 0 0 1 0-3.32l3.438-3.437a2.354 2.354 0 0 1 3.32 0 2.353 2.353 0 0 1 0 3.32ZM61.467 50.133l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32ZM72.176 50.133l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32Z",
    fill: "#D78C02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.817 76.173H9.292a2.29 2.29 0 0 1-2.288-2.288v-10.84a2.29 2.29 0 0 1 2.288-2.287h67.525a2.29 2.29 0 0 1 2.289 2.288v10.839a2.283 2.283 0 0 1-2.289 2.288Z",
    fill: "#FED896"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.05 72.273a3.813 3.813 0 1 0 0-7.627 3.813 3.813 0 0 0 0 7.627Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m51.112 68.406-3.438 3.438a2.354 2.354 0 0 1-3.32 0 2.354 2.354 0 0 1 0-3.32l3.438-3.437a2.354 2.354 0 0 1 3.32 0 2.353 2.353 0 0 1 0 3.32ZM61.467 68.406l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32ZM72.176 68.406l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32Z",
    fill: "#D78C02"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.817 94.445H9.292a2.29 2.29 0 0 1-2.288-2.288v-10.85a2.29 2.29 0 0 1 2.288-2.288h67.525a2.29 2.29 0 0 1 2.289 2.289v10.838a2.292 2.292 0 0 1-2.289 2.3Z",
    fill: "#FED896"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M16.05 90.546a3.814 3.814 0 1 0 0-7.627 3.814 3.814 0 0 0 0 7.627Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m51.112 86.668-3.438 3.438a2.354 2.354 0 0 1-3.32 0 2.354 2.354 0 0 1 0-3.32l3.438-3.437a2.354 2.354 0 0 1 3.32 0 2.353 2.353 0 0 1 0 3.32ZM61.467 86.668l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32ZM72.176 86.668l-3.438 3.438a2.353 2.353 0 0 1-3.319 0 2.353 2.353 0 0 1 0-3.32l3.438-3.437a2.353 2.353 0 0 1 3.319 0 2.334 2.334 0 0 1 0 3.32Z",
    fill: "#D78C02"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Frame2_svg__a",
    x1: 63.488,
    y1: 18.006,
    x2: 63.488,
    y2: 67.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC15C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD181"
  })))));
};
export default SvgFrame2;